import { EFinancingProgram } from '@if/core/types'
import { AvailableCredit } from '@src/data/types'
import allApi from '../../api'
import { makeGetById } from '../effects/standard-side-effects'
import { availableCreditSlice, GET_AVAILABLE_CREDIT } from './available-credit-store'

const availableCreditEffects = {
  getAvailableCredit: (id: string, financingProgramId: EFinancingProgram) =>
    makeGetById<AvailableCredit>(
      GET_AVAILABLE_CREDIT,
      allApi.availableCredit.getAvailableCredit,
      availableCreditSlice.actions.setAvailableCredit,
      { id, financingProgramId },
    ),
}

export default availableCreditEffects
